import React, { useState } from 'react';
import { Navigate   } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import StateDropdown from '../StateDropdown';
import '../styles.css';

export const State = () => {
    const [stateId, setStateId] = useState('');
    const [selectedStateName, setSelectedStateName] = useState('');
    const [redirect, setRedirect] = useState(false);

    const handleStateChange = (selectedStateId, selectedStateName) => {
        setStateId(selectedStateId);
        setSelectedStateName(selectedStateName);
        if(selectedStateId && selectedStateName){
          setRedirect(true);
        }
    };

  return (
    <div className="state-container">
      <h1>Global Navigation Satellite System (GNSS) Interference Detection Using C/N0 Data from Public Databases</h1>
      <br />
      <p>
        This application displays current and past-time distributions in time and space of suspected jamming events detected over the continental United States using publicly
        {/* <br/> */}
        available data mainly obtained from the NOAA National Geodetic Survey’s Continuously Operating Reference Stations (CORS: <a href="https://geodesy.noaa.gov/CORS/">https://geodesy.noaa.gov/CORS/</a>).
        {/* <br/> */}
        Suspected jamming events are identified using simultaneous drops in carrier to noise ratio (C/N0) using a robust, self-calibrating, high-sensitivity detector.
        {/* <br /> */}
        The detector minimizes the risk of missed detection while limiting the risk of false alerts.
        <br />
        <br />
        Please do not hesitate to contact us at <a href="mailto:joerger@vt.edu">joerger@vt.edu</a> . If this work is useful to your research, please acknowledge our
        {/* <br/> */}
         contribution using the following reference :
        <br/>
        <br/>
        <cite>
          Jada, S., S. Landerkin, M. Psiaki, S. Langel, A. Scholz, and M. Joerger, “Evaluation of PNT Situational Awareness Algorithms
          {/* <br/>  */}
          and Methods” Proceedings of the 34th International Technical Meeting of The Satellite Division of the Institute
          {/* <br/>  */}
          of Navigation (ION GNSS+ 2021). Saint Louis, MO (2021).
        </cite>
        <br/>
        <br/>
        This webpage is still under construction. The following map distinguishes states for which data is processed (in green)
        {/* <br/> */}
        from those for which it is not (in red). Please select a <strong>green-colored state</strong> to access 
        {/* <br/> */}
        state-wide jamming event maps.
      </p>

      <br />
      <>
        <StateDropdown onSelect={handleStateChange} />
        {redirect && <Navigate  to={`/sites/${stateId}/${selectedStateName}`} />}
      </>
      {/* <br />
      {stateId && (
        <>
          <p>
          <br />
            Click on the following button to see all the observation sites present in the selected state
          </p>
          <br />
          <button className="state-dropdown">
            <Link to={`/sites/${stateId}/${selectedStateName}`}>View Sites</Link>
          </button>
        </>
      )} */}

    </div>
  );
};